import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { map, switchMap, finalize } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Table } from 'primeng/table';

import { environment } from 'src/environments/environment';

import { GlobalConnSettings, GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry } from 'src/app/shared/doc-list-entry';
import { SalesLead, SalesLeadItem } from 'src/app/shared/sales-leads';
import { SalesApiService } from 'src/app/services/sales-api.service';

@Component({
  selector: 'app-list-sales-lead-items',
  templateUrl: './list-sales-lead-items.component.html',
  styleUrls: ['./list-sales-lead-items.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ListSalesLeadItemsComponent implements OnInit, OnDestroy, OnChanges {

  @Input() salesLeadId: number;

  globalSettinsData: GlobalSettingsData;

  @ViewChild('ptable4') ptable4: Table;

  salesLead: SalesLead;
  salesLeadItems: SalesLeadItem[];

  selectedSalesLeadItem: SalesLeadItem;

  salesLeadItemsQuery: Subscription;
  totalSalesLeadItems: number;

  loading: boolean = false;
  private salesLeadItemsSubj$ = new Subject<number>();

  public get paginator(): boolean { return (this.salesLeadItems || []).length > 10; }

  // to store f[string] filters value

  cf4: any = {};

  constructor(
    private filterService: FilterService,
    private salesApi: SalesApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  loadSalesLeadItems() {
    this.loading = true;
    this.salesLeadItemsQuery =
      this.salesLeadItemsSubj$
        .pipe(
          switchMap(slId => this.salesApi.getSalesLeadItems(slId).pipe(

            map(data => {
              this.salesLeadItems = data || [];
              this.totalSalesLeadItems = this.salesLeadItems.length;
              this.docListCalculatedFields(this.salesLeadItems);
              environment.production || console.table(this.salesLeadItems);
            }),
            finalize(() => {
              this.loading = false;
            })
          )))
        .subscribe();

    this.salesLeadItemsSubj$.next(this.salesLeadId);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** ListSalesLeadItemsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      //environment.production || console.log('*** ListSalesLeadItemsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //environment.production || console.log('*** ListSalesLeadItemsComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'salesLeadId':
          if (this.globalSettinsData) {
            this.salesLeadItemsSubj$.next(change.currentValue);
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** ListSalesLeadItemsComponent in ngOnDestroy");

    if (this.salesLeadItemsQuery) { this.salesLeadItemsQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** ListSalesLeadItemsComponent in ngOnInit");

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.loadSalesLeadItems();
  }

  docListCalculatedFields(orderList: DocListEntry[]) {

    let jn: Date = new Date();
    let td: Date = new Date();
    td.setHours(0, 0, 0, 0);
    let tm: Date = new Date(td);
    tm.setHours(23, 59, 59);

    orderList.forEach((dc: DocListEntry) => {
      dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

      dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

      dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

      dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

      dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

      dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

      dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

      dc.fd = (new Date(dc.DOCDATE) > tm);
    });
  }
}
